<template>
  <div class='pagination'>
    <ul class="pagination-list">
      <li class="pagination-item">
        <button type="button" @click="onClickFirstPage" v-show="!isInFirstPage" class="pagination-btn">
          FIRST
        </button>
      </li>
      <li class="pagination-item">
        <button type="button" @click="onClickPreviousPage" v-show="!isInFirstPage" class="pagination-btn">
          << PRESIOUS
        </button>
      </li class="pagination-item">
      <li v-for="page in pages" class="pagination-item">
        <button
          type="button"
          @click="onClickPage(page.name)"
          :disabled="page.isDisabled"
          class="pagination-btn"
          :class="{ active: isPageActive(page.name) }"
        >
          {{ page.name }}
        </button>
      </li>
      <li class="pagination-item">
        <button type="button" @click="onClickNextPage" v-show="!isInLastPage" class="pagination-btn">
          NEXT >>
        </button>
      </li>
      <li class="pagination-item">
        <button type="button" @click="onClickLastPage" v-show="!isInLastPage" class="pagination-btn">
          LAST
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'pagination',
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true,
    }
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }
      // When on the last page
      // if (this.currentPage === this.totalPages) {
      //   return this.totalPages - this.maxVisibleButtons;
      // }
      if (this.currentPage === this.totalPages) { 
        return this.totalPages - this.maxVisibleButtons + 1;
      }
      // When in between
      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages() {
      const range = [];
      for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    }
  }
};
</script>

<style>
.pagination {
  width: 100%;
}

.pagination-list {
  list-style-type: none;
  margin: 50px 0;
  text-align: center;
}
 
.pagination-item {
  display: inline;
}

.pagination-btn {
  font-size: 15px;
  font-weight: 700;
  margin: 0 5px;
  padding: 10px;
  border: none;
  cursor: pointer;
}

.active {
  color: #0f2341;
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue